import { render, staticRenderFns } from "./VariantForm.vue?vue&type=template&id=60f90abc&scoped=true&"
import script from "./VariantForm.vue?vue&type=script&lang=js&"
export * from "./VariantForm.vue?vue&type=script&lang=js&"
import style0 from "./VariantForm.vue?vue&type=style&index=0&id=60f90abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f90abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f90abc')) {
      api.createRecord('60f90abc', component.options)
    } else {
      api.reload('60f90abc', component.options)
    }
    module.hot.accept("./VariantForm.vue?vue&type=template&id=60f90abc&scoped=true&", function () {
      api.rerender('60f90abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/modals/FieldReferenceBook/VariantForm.vue"
export default component.exports